import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

const ClosePopup = ({ open, handleClosePopup, handleSave, note, setNote }) => {
  const maxMessageLength = 250;
  return (
    <Dialog
      open={open}
      onClose={handleClosePopup}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px",
          },
        },
      }}
    >
      <DialogTitle>Close Note</DialogTitle>
      <DialogContent>
        <TextField
          sx={{ mt: 2 }}
          size="small"
          margin="none"
          id="note"
          name="note"
          label="Note"
          required
          fullWidth
          multiline
          rows={4}
          value={note}
          onChange={(e) => {
            if (e.target.value.length <= maxMessageLength)
              setNote(e.target.value);
          }} // Update search term
          helperText={`${note.length}/${maxMessageLength}`}
          FormHelperTextProps={{
            sx: {
              textAlign: "right",
              color: note.length >= maxMessageLength ? "error.main" : "inherit",
              mt: 1,
              fontSize: "0.65rem",
              fontWeight: 600,
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClosePopup} variant="outlined">
          Chiudi
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={!note?.trim()}
        >
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClosePopup;
